import { OAuth2AccessTokenDTO } from '@higo/api/src/models';
import { flatten } from '@higo/api/src/utils';
import { AxiosInstance } from 'axios';

export type PartnerExaminationOTP = string;
export type ExaminationSharingToken = string;

export const fetchPartnerExaminationJWTForExams =
  (axios: AxiosInstance) => (examCode: PartnerExaminationOTP) =>
    axios
      .post<OAuth2AccessTokenDTO>('api/tokens/code', { examCode })
      .then(flatten);

export const fetchPartnerExaminationJWTForVisits =
  (axios: AxiosInstance) => (visitCode: PartnerExaminationOTP) =>
    axios
      .post<OAuth2AccessTokenDTO>('api/tokens/visits/code', { visitCode })
      .then(flatten);

export const fetchSharedExaminationJWT =
  (axios: AxiosInstance) => (token: ExaminationSharingToken) =>
    axios
      .post<OAuth2AccessTokenDTO>('api/tokens/examination', { token })
      .then(flatten);

export const fetchSharedVisitJWT =
  (axios: AxiosInstance) => (token: ExaminationSharingToken) =>
    axios
      .post<OAuth2AccessTokenDTO>('api/tokens/visits', { token })
      .then(flatten);
